import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export const eventAlert = [
  {
    value: 'projectName',
    id: 'projectName',
    text: $t('searchLabel.projectName'),
    sortable: false,
    isVisible: true,
    width: 192
  },
  {
    value: 'productTypeCode',
    id: 'productTypeCode',
    text: $t('searchLabel.productTypeCode'),
    defaultValue: '',
    sortable: true,
    width: 137
  },
  {
    value: 'productName',
    id: 'productName',
    text: $t('searchLabel.productName'),
    sortable: true,
    defaultValue: '',
    isVisible: true,
    width: 287
  },
  {
    value: 'eventMessage',
    id: 'eventMessage',
    text: $t('searchLabel.eventMessage'),
    sortable: true,
    bodyAlign: 'left',
    defaultValue: ''
  },
  {
    value: 'eventLevel',
    id: 'eventLevel',
    text: $t('searchLabel.eventLevel'),
    sortable: true,
    defaultValue: '',
    width: 125
  },
  {
    value: 'eventState',
    id: 'eventState',
    text: $t('searchLabel.eventState'),
    width: 126,
    sortable: true,
    defaultValue: ''
  },
  {
    value: 'occurrenceDate',
    id: 'occurrenceDate',
    text: $t('searchLabel.occurrenceDate'),
    isNotResize: true,
    sortable: true,
    width: 170,
    defaultValue: ''
  },
  {
    value: 'durationTime',
    id: 'durationTime',
    text: $t('searchLabel.occurrenceDate'),
    isNotResize: true,
    sortable: true,
    defaultValue: '',
    width: 143
  }
];
